import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllInquiry = createAsyncThunk(
  "Inquiry/FindAllInquiry",
  async (formdata: any, { rejectWithValue }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Inquiry/FindAllInquiry`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Inquiry:", error);
      return rejectWithValue({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
